import { conversationsLicenses } from "@sourcewhale/shared/src/assets/js/src/general/licenses";

export const todoQueryLicenseMap = {
  phoneCall: ["outreach"],
  sendEmailAfterInmail: ["outreach"],
  sendInmail: ["outreach"],
  linkedinConnectionRequest: ["outreach"],
  generalTask: ["outreach"],
  bounce: ["outreach"],
  manualToDo: ["projects"],
  opportunity: ["outreach"],
  aiToDo: ["outreach", "notetaker", ...conversationsLicenses],
};

export const kindsToAnyOf = (kinds) =>
  kinds.flatMap((kind) => todoQueryLicenseMap[kind]);
